import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from '../../../shared/shared.service';
import { LoaderService } from '../../../core/services/loader.service';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  createGateway,
  updateGateWay,
} from '../../../store/GateWay/gateway.action';
import { Validations } from '../../../shared/constants/validations';
import {
  createthirdpartyapi,
  updatethirdpartyapi,
} from '../../../store/thirdpartyapis/thirdpartyapis.action';
import { Helper } from '../../../core/helpers/helper';

Validations;
@Component({
  selector: 'app-rp-create-thirdparty',
  templateUrl: './rp-create-thirdparty.component.html',
  styleUrl: './rp-create-thirdparty.component.scss',
})
export class RpCreateThirdpartyComponent {
  fileValidations = Validations.ThirdPartyPage;
  creategatewayForm!: UntypedFormGroup;
  currentUserData: any;
  submitted: boolean = false;
  selectedGateway: any;
  @Input() projectId: any;
  @Input() thirdpartyUpdateData: any;
  configData: any;
  gatewayProvidersList: any[] = [];
  regex = /^[a-zA-Z0-9]+$/;
  listofProjects: any = [];
  endpointTypes: any[] = [];
  constructor(
    private router: Router,
    private store: Store,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.creategatewayForm = this.formBuilder.group({
      endpointName: [
        '',
        [
          Validators.required,
          Validators.maxLength(200),
          Helper.noWhitespaceValidator(),
        ],
      ], // Optional
      projectId: [null, Validators.required], // Mandatory if project selection is critical
      url: [
        '',
        [
          Validators.required,
          // Validators.pattern(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i),
          Validators.pattern(
            /^(https?|ftp):\/\/[A-Za-z0-9._~:\/\?\#\[\]@!$&'()*+,;=%-]+$/i,
          ),
        ],
      ], // Optional
      type: [null, Validators.required],
      apikeyToken: ['', Validators.pattern(/^[A-Za-z0-9]+( [A-Za-z0-9]+)?$/)],
      ishmwssb: [false],
      hmwssbType: [true],
      description: ['', []], // Optional
    });
  }

  ngOnInit(): void {
    this.getAllConfigData();
  }
  get gatewayControls() {
    return this.creategatewayForm.controls;
  }
  onSwitchChange(event: any) {
    console.log(event);
    if (event) {
      this.creategatewayForm
        .get('apikeyToken')
        ?.setValidators([
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]+( [A-Za-z0-9]+)?$/),
        ]);
      this.creategatewayForm.get('apikeyToken')?.updateValueAndValidity();
    } else {
      this.creategatewayForm.get('apikeyToken')?.clearValidators();
      this.creategatewayForm.get('apikeyToken')?.updateValueAndValidity();
    }
  }

  getAllConfigData(): void {
    this.sharedService.getAllConfigData().subscribe((data: any) => {
      if (
        data.statusCode === 200 &&
        data.message === 'Config data retrieved successfully.'
      ) {
        const configData = data.data ?? {};

        // Project dropdown
        this.listofProjects = configData.projects ?? [];

        // Find the array containing Billing and Gateway options
        const configArrays = Object.values(configData).filter((value: any) =>
          Array.isArray(value),
        ) as any[][];

        const endpointConfigArray =
          configArrays.find(
            (items: any[]) =>
              items.some(
                (item: any) => item?.name?.trim().toLowerCase() === 'billing',
              ) &&
              items.some(
                (item: any) => item?.name?.trim().toLowerCase() === 'gateway',
              ),
          ) ?? [];

        // Show only options whose type is Webhook
        this.endpointTypes = endpointConfigArray.filter(
          (item: any) => item?.type?.name?.trim().toLowerCase() === 'webhook',
        );

        // Default selection: Billing
        const billingType = this.endpointTypes.find(
          (item: any) => item.name?.trim().toLowerCase() === 'billing',
        );


        this.creategatewayForm.patchValue({
          endpointName: this.thirdpartyUpdateData?.endpointName ?? '',

          projectId: this.thirdpartyUpdateData?.projectId ?? null,

          type: this.thirdpartyUpdateData?.type ?? "Billing", 

          url: this.thirdpartyUpdateData?.url ?? '',

          description: this.thirdpartyUpdateData?.description ?? '',

          ishmwssb: this.thirdpartyUpdateData?.isHmwssb ?? false,

          hmwssbType: this.thirdpartyUpdateData?.isImmediate ?? true,

          apikeyToken: this.thirdpartyUpdateData?.apiKey ?? '',
        });
      }
    });
  }

  valueChange(value: any): void {
    console.log('valueChange', value);
    this.selectedGateway = value;
  }

  getProjectNameById(id: string): string | undefined {
    const project = this.listofProjects.find(
      (project: any) => project.id === id,
    );
    return project ? project.name : undefined; // Returns the name or undefined if not found
  }

  findInvalidControls(form: any): { [key: string]: any }[] {
    const invalidControls = [];
    const controls = form.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push({
          controlName: name,
          controlErrors: controls[name].errors,
        });
      }
    }

    return invalidControls;
  }

  saveThirdParty(type: string) {
    this.submitted = true;
    const invalidControls = this.findInvalidControls(this.creategatewayForm);
    console.log('Invalid controls:', invalidControls);
    console.log(this.creategatewayForm.value);
    if (this.creategatewayForm.valid) {
      this.loaderService.setLoading(true);
      let payload = {
        endpointName: this.creategatewayForm.get('endpointName')?.value,
        projectName: this.getProjectNameById(
          this.creategatewayForm.get('projectId')?.value,
        ),
        projectId: this.creategatewayForm.get('projectId')?.value,
        url: this.creategatewayForm.get('url')?.value,
        description: this.creategatewayForm.get('description')?.value,
        apiKey: this.creategatewayForm.get('apikeyToken')?.value,
        type: this.creategatewayForm.get('type')?.value ?? 'Billing',
        isHmwssb: this.creategatewayForm.get('ishmwssb')?.value,
        isImmediate: this.creategatewayForm.get('hmwssbType')?.value,
      };

      console.log(payload); // To check the created payload

      console.log(payload);
      console.log(this.creategatewayForm.value);
      if (type == 'Create') {
        this.store.dispatch(createthirdpartyapi({ thirdparty: payload }));
      } else if (type == 'Update') {
        let payload = {
          endpointName: this.creategatewayForm.get('endpointName')?.value,
          projectName: this.getProjectNameById(
            this.creategatewayForm.get('projectId')?.value,
          ),
          projectId: this.creategatewayForm.get('projectId')?.value,
          url: this.creategatewayForm.get('url')?.value,
          description: this.creategatewayForm.get('description')?.value,
          id: this.thirdpartyUpdateData.id,
          apiKey: this.creategatewayForm.get('apikeyToken')?.value,
          type: this.creategatewayForm.get('type')?.value ?? 'Billing',
          isHmwssb: this.creategatewayForm.get('ishmwssb')?.value,
          isImmediate: this.creategatewayForm.get('hmwssbType')?.value,
        };
        console.log(this.creategatewayForm.value);
        this.store.dispatch(updatethirdpartyapi({ updatedData: payload }));
      }
      this.modalService.hide();
    }
  }

  dismissModal(): void {
    this.modalService.hide();
  }
}
